import { z } from 'zod';

export const apiHealthSchema = z.object({
  service: z.literal('killer-party-api'),
  status: z.literal('ok'),
  timestamp: z.string().datetime(),
});

export type ApiHealth = z.infer<typeof apiHealthSchema>;